import { vars } from '@croquiscom-pvt/zds/tokens';

export const IconCheckSolidNew = ({
  width = 20,
  height = 20,
  backgroundColor = vars.color.fillTertiary,
  color = vars.color.iconQuaternary,
}: JSX.IntrinsicElements['svg'] & {
  backgroundColor?: string;
  color?: string;
}) => (
  <svg width={width} height={height} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='10' cy='10' r='10' fill={backgroundColor} />
    <path
      d='M5.45312 10.4553L9.08949 14.0916L14.544 7.27344'
      stroke={color}
      strokeWidth='2.3'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
